import breederApi from "@/app/apis/main/breeder/breeder-api.js";

export default {
    async updateBreederDetails(details) {
        return breederApi.updateBreederDetails(details);
    },

    async approvedDeclinedBreeder(details) {
        return breederApi.approvedDeclinedBreeder(details);
    },

    async getBreedersList(queryParams) {
        return breederApi.getBreedersList(queryParams);
    },

    async getBreedersSuggestionList(queryParams) {
        return breederApi.getBreedersSuggestionList(queryParams);
    },

    async getBreederDetailsById(breederId) {
        return breederApi.getBreederDetailsById(breederId);
    },

    async getUnverifiedBreeder() {
        return breederApi.getUnverifiedBreeder();
    },

    async reactivateDeactivateBreeder(details) {
        return breederApi.reactivateDeactivateBreeder(details);
    },

    /**
     * @param {*} breederDetails
     * @returns {Promise}
     */
    async addBreeder(breederDetails) {
        return breederApi.addBreeder(breederDetails);
    },

    async deleteBreeder(breederId) {
        return breederApi.deleteBreeder(breederId);
    },

    async getBreederById(userId) {
        return breederApi.getBreederById(userId);
    },

    async addBreederBio(details) {
        return breederApi.addBreederBio(details);
    },

    async updateBreederBio(details) {
        return breederApi.updateBreederBio(details);
    },
};
